module.exports = __webpack_public_path__ + "./docs/img/dart.b5f96e7144a890e13fbc62d56c2af4ad.svg";